import axios from "axios";
import jwtDecode from "jwt-decode";
import Endpoints from "variables/charts";
import { OnlyNumbers, IsEmpty } from "config/functions";
import {
  Endereco,
  TipoEndereco,
  TipoLogradouro,
} from "views/admin/atendimento/profile/components/Cliente";

export const authLoginRequest = (userData, password) => {
  const body = {
    usuario: OnlyNumbers(userData),
    senha: password,
  };
  return axios
    .post(Endpoints.autenticacao, body)
    .then((response) => {
      const usuario = jwtDecode(response?.data?.token);
      if (!IsEmpty(usuario.perfis) && response.status === 200) {
        const { token } = response.data;
        return { usuario, token };
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

const toEndereco = (cliente, endereco) => {
  const tipoEndereco = new TipoEndereco();
  if (cliente.idTipoEndereco === 1) {
    tipoEndereco.descricao = "COMERCIAL";
  } else {
    tipoEndereco.descricao = "RESIDENCIAL";
  }
  tipoEndereco.codigo = cliente.idTipoEndereco;
  const tipoLogradouro = new TipoLogradouro();
  tipoLogradouro.id = cliente.idTipoLogradouro;

  return {
    ...endereco,
    nrSeqEndereco: cliente.nrSeqEndereco,
    logradouro: cliente.logradouro,
    complemento: cliente.complemento,
    bairro: cliente.bairro,
    cidade: cliente.cidade,
    uf: cliente.uf,
    cep: cliente.cep,
    numero: cliente.numero,
    latitude: 0.0,
    longitude: 0.0,
    tipoEndereco,
    tipoLogradouro,
  };
};

export const alteraClienteAtendimento = (params) => {
  let endereco = toEndereco(params, new Endereco());
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  if (endereco?.cep === undefined) {
    endereco = null;
  }
  return axios
    .put(`${Endpoints.CadastroCliente}`, params)
    .then((response) => {
      buscaNrSeqCliente(params.id).then(function (result) {
        if (result?.data?.length > 0 && endereco?.cep !== null) {
          alteraEndereco(params.id, endereco);
        } else {
          if (endereco?.cep !== null && endereco?.cep !== undefined) {
            salvaEndereco(params.id, endereco);
          }
        }
      });

      return response.request.status;
    })
    .catch((err) => {
      return 500;
    });
};

export const alteraClienteAtendimento2 = (params) => {
  let endereco = toEndereco(params, new Endereco());
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  if (endereco?.cep === undefined) {
    endereco = null;
  }
  return axios
    .put(`${Endpoints.CadastroClienteAtendimento}`, params)
    .then((response) => {
      buscaNrSeqCliente(params.id).then(function (result) {
        if (result?.data?.length > 0 && endereco?.cep !== null) {
          alteraEndereco(params.id, endereco);
        } else {
          if (endereco?.cep !== null && endereco?.cep !== undefined) {
            salvaEndereco(params.id, endereco);
          }
        }

        //082.196.000-80
      });

      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const alteraClienteAtendimentoFoto = (params) => {
  const endereco = toEndereco(params, new Endereco());
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(`${Endpoints.CadastroClienteAtendimento}`, params)
    .then((response) => {
      return response.request.status;
    })
    .catch((err) => {
      return 500;
    });
};

//TODO
export const checkUserDoc = (numeroDocumento, nome, dataNascimento) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  const body = {
    nationalRegistration: numeroDocumento,
    name: nome,
    birthDate: dataNascimento,
    //token: params.token,
  };
  return axios
    .post(Endpoints.VerificaDadosDoc, body)
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const cadastraCliente = (params) => {
  const endereco = toEndereco(params, new Endereco());
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.CadastroCliente, params)
    .then((response) => {
      if (typeof endereco.cep !== "undefined" && endereco.cep !== "") {
        salvaEndereco(
          params.id ? params.id : response?.data?.codigo,
          endereco,
        ).then(function (result) {
          if (result < 400) {
            return response.request.status;
          } else {
            return 400;
          }
        });
      }
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const pesquisaCartaoAvulso = async (bodyAvulso) => {
  var dataFinal = "";
  let dataIni = "";

  dataIni = formataDataFiltro(bodyAvulso.dateRangeApi.startDate);
  dataFinal = formataDataFiltro(bodyAvulso.dateRangeApi.endDate);

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  const body = {
    numeroCartao: bodyAvulso.numeroCartao,
    dataInicio: dataIni,
    dataFim: dataFinal,
    idProduto: bodyAvulso.idProduto,
  };
  return await axios
    .post(Endpoints.GetHistoricoExtratoAvulso, body)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      return err;
    });
};

export const consultaDadosMedicosPCD = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.ConsultarDadosMedicos(id))
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch(() => {
      return 500;
    });
};

export const consultaEstudanteGratuidade = async (body) => {
  try {
    axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

    const response = await axios.post(Endpoints.ConsultarEstudante, body);

    if (response.status < 400) {
      return response.data;
    }

    return {
      status: response.status,
      mensagem: "Erro na requisição",
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      mensagem: error.response?.data?.mensagem || "Erro desconhecido",
    };
  }
};

export const salvarEstudanteNaEscola = (
  type,
  codCliente,
  cpf,
  matricula,
  codEscola,
  nomeCliente,
  dataNascimentoCliente,
  celular,
  nomeMae,
  email,
) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  if (type === 0)
    return axios
      .post(Endpoints.SalvaEstudanteEscola, {
        cdCliente: codCliente,
        numeroMatricula: matricula,
        codigoEscola: codEscola,
        nome: nomeCliente,
        cpf: cpf,
        dataNascimento: dataNascimentoCliente,
        telefone: celular,
        nomeMae: nomeMae,
        email: email,
        idTipoEnsino: 8,
      })
      .then((response) => {
        if (response.status < 400) {
          return response.data;
        } else {
          return 400;
        }
      })
      .catch((err) => {
        return 500;
      });
  return axios
    .put(Endpoints.SalvaEstudanteEscola, {
      cdCliente: codCliente,
      cpf: cpf,
      numeroMatricula: matricula,
      codigoEscola: codEscola,
      nome: nomeCliente,
      dataNascimento: dataNascimentoCliente,
      telefone: celular,
      nomeMae: nomeMae,
      email: email,
      idTipoEnsino: 8,
    })
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const alterarEstudanteNaEscola = (
  type,
  codCliente,
  cpf,
  matricula,
  codEscola,
  nomeCliente,
  dataNascimentoCliente,
  celular,
  nomeMae,
  email,
) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  if (type === 0)
    return axios
      .put(Endpoints.SalvaEstudanteEscola, {
        cdCliente: codCliente,
        cpf: cpf,
        numeroMatricula: matricula,
        codigoEscola: codEscola,
        nome: nomeCliente,
        dataNascimento: dataNascimentoCliente,
        telefone: celular,
        nomeMae: nomeMae,
        email: email,
      })
      .then((response) => {
        if (response.status < 400) {
          return response.data;
        } else {
          return 400;
        }
      })
      .catch((err) => {
        return 500;
      });
  return axios
    .put(Endpoints.SalvaEstudanteEscola, {
      cdCliente: codCliente,
      cpf: cpf,
      numeroMatricula: matricula,
      codigoEscola: codEscola,
      nome: nomeCliente,
      dataNascimento: dataNascimentoCliente,
      telefone: celular,
      nomeMae: nomeMae,
      email: email,
    })
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const alterarDadosMedicos = (body) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.AlteraDadosMedicosPCD, body)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const cadastrarDadosMedicos = (body) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.CadastraDadosMedicosPCD, body)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const associarCartaoApi = (body) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.AssociarCartaoAvulso, body)
    .then((response) => {
      if (response.status < 400) {
        return response.status;
      } else {
        return response?.data?.errorMessages || 400;
      }
    })
    .catch((err) => {
      return err;
    });
};

export const cadastrarProtocolo = (userData, observacao) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "/" + mm + "/" + yyyy;

  const bodyDesk = {
    subject: "Criação de chamado cliente: " + userData.numeroDocumento,
    description:
      observacao !== ""
        ? decodeURI(observacao)
        : "Criação do chamado " + formattedToday,
    requesterName: userData.nome,
    requesterEmail: userData.email,
  };

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.CadastroProtocolo, bodyDesk)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 400;
    });
};

export const alterarProtocolo = (userData, observacao, idChamado) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "/" + mm + "/" + yyyy;

  const bodyDesk = {
    id: idChamado,
    subject: "Criação de chamado cliente: " + userData.numeroDocumento,
    description:
      observacao !== ""
        ? decodeURI(observacao)
        : "Criação do chamado " + formattedToday,
    requesterName: userData.nome,
    requesterEmail: userData.email,
  };

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.CadastroProtocolo, bodyDesk)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 400;
    });
};

export const cadastrarProtocoloComentario = (ticket, observacao) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.CadastroProtocoloComentario(ticket), observacao)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const pesquisarProtocoloComentario = (ticket) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.PesquisarProtocoloComentario(ticket))
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const buscarPedidosPorId = (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.PesquisarPedidosPorId(id))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const PesquisarItensPedidosPorId = (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.PesquisarItensPedidosPorId(id))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const buscarItemPedidoPorIdCliente = (idCliente, idProduto) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.PesquisarNrRastreioPorIdCliente(idCliente, idProduto))
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const pesquisarDataSenior = (data) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.PesquisarDataSenior(data))
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const listarQrCodePorCliente = (numDoc) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.ListarQrCodePorCliente(numDoc))
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const listarUnidadesUap = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.ListarUap)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const listarCids = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.ListarCids)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const buscartHistoricoUtilizacaoDeQRs = (data) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.BuscartHistoricoUtilizacaoDeQRs, data)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const atualizarProtocolo = (bodyDesk) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.CadastroProtocolo, bodyDesk)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const fecharProtocolo = (ticket) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.FecharProtocolo(ticket))
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.status;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const criarImagemMultiFace = (
  imagemUser,
  cpfUser,
  nomeUser,
  dtNascimento,
  tipoDocumento,
) => {
  const body = {
    nome: nomeUser,
    dataNascimento: dtNascimento,
    numeroDocumento: cpfUser,
    imagem: imagemUser,
    tipoDocumento: tipoDocumento,
  };
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.CriarImagemMultiFace, body)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const criarImagemMultiFaceForce = (
  imagemUser,
  cpfUser,
  nomeUser,
  dtNascimento,
  forceImagem,
  tipoDocumento,
) => {
  const body = {
    nome: nomeUser,
    dataNascimento: dtNascimento,
    numeroDocumento: cpfUser,
    imagem: imagemUser,
    force: forceImagem || false,
    tipoDocumento: tipoDocumento,
  };
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.CriarImagemMultiFaceForce, body)
    .then((response) => {
      if (
        (response.status >= 200 && response.status < 400) ||
        response.status != 413
      ) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 413;
    });
};

export const atualizarImagemMultiFace = (
  imagemUser,
  cpfUser,
  forceMultiface,
  tipoDocumento,
) => {
  const body = {
    numeroDocumento: cpfUser,
    imagem: imagemUser,
    force: forceMultiface || false,
    tipoDocumento: tipoDocumento,
  };
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.AtualizarImagemMultiFace, body)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 400;
    });
};

export const atualizarImagemMultiFaceForce = (
  imagemUser,
  cpfUser,
  forceMultiface,
  tipoDocumento,
) => {
  const body = {
    numeroDocumento: cpfUser,
    imagem: imagemUser,
    force: forceMultiface || false,
    tipoDocumento: tipoDocumento,
  };
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.AtualizarImagemMultiFaceForce, body)
    .then((response) => {
      if (response.status >= 200 || response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 400;
    });
};

export const consultarImagemMultiFace = (cpfUser) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.ConsultarImagemMultiFace(cpfUser))
    .then((response) => {
      return response?.data;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const editaCliente = (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.EditarCliente, params)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else return [];
    })
    .catch((erro) => console.log("Erro ao editar cliente", erro));
};

const alteraEndereco = (cliente, endereco) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.EnderecoCliente(cliente), endereco)
    .then((response) => {
      return response.status;
    })
    .catch((erro) => console.log("Erro Alterar endereco", erro));
};

export const buscaNrSeqCliente = (idCliente) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.BuscarNrSeqCliente(idCliente))
    .then((response) => {
      return response;
    })
    .catch((erro) => console.log("Erro buscar nrseq endereco", erro));
};

const salvaEndereco = (cliente, endereco) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.EnderecoCliente(cliente), endereco)
    .then((response) => {
      return response.status;
    })
    .catch((erro) => console.log("Erro Alterar endereco", erro));
};

export const pesquisaCliente = (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(`${Endpoints.Cliente}/search`, params)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const getAllStatusGratuidade = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.getAllStatusGratuidade)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch(() => {
      return 500;
    });
};

export const pesquisaEstudante = (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(`${Endpoints.Cliente}/search/estudante`, params)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const getOperadoras = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.Operadoras)
    .then((response) => {
      if (response.status == 403 || response.status == 401) {
        return 403;
      } else if (response.status == 200) {
        return response.data;
      } else {
        return 404;
      }
    })
    .catch((err) => {
      return 403;
    });
};

export const getGrupos = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.ListaGrupos)
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
    });
};

export const getEscolas = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.ListaEscolas)
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
    });
};

export const getLinhas = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.Linhas)
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
    });
};

export const desbloqueioContaUsoIndevido = async (bodyRequest) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .post(Endpoints.desbloqueioContaUsoIndevido, [bodyRequest])
    .then((response) => response)
    .catch((err) => {
      console.error(err);
      return err?.response?.status || 500;
    });
};

export const getImagemTransacao = async (idImagemTransacao) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.GetImagemTransacao(idImagemTransacao))
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
    });
};

export const getBloqueioContas = async (numeroDocumento) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.GetBloqueioContas(numeroDocumento))
    .then((response) => response.data)
    .catch((err) => {
      console.error(err);
    });
};

export const getSearchLinha = async (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.BuscaPorNomeLinha}/${params}`)
    .then((response) => response.data)
    .catch((err) => {
      console.error(err?.response?.status);
    });
};

export const pesquisaCartoesCliente = async (user) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.GetMidiaAssociacao}/${user.codigo}`)
    .then((response) => {
      if (response.status < 400) {
        return Promise.resolve(response.data);
      } else if (response.status > 400 && response.status < 500) {
        return Promise.resolve("400");
      }
    })
    .catch((err) => {
      return Promise.resolve(err?.response?.status);
    });
};

const formataDataFiltro = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const buscarHistoricoExtrato = async (
  user,
  datas,
  buscaSete,
  idProdutoMidia,
) => {
  var dataFinal = "";
  let dataIni = "";

  dataIni = formataDataFiltro(datas.startDate);
  dataFinal = formataDataFiltro(datas.endDate);

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  const body = {
    idCliente: user,
    dataInicio: dataIni,
    dataFim: dataFinal,
    idProduto: idProdutoMidia,
    periodo: 5,
  };
  return await axios
    .post(Endpoints.GetHistoricoExtratoCompleto, body)
    .then((response) => {
      return Promise.resolve(response?.data);
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const consultarGratuidadePcd = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.ConsultaGratuidadePcd(id)}`)
    .then((response) => {
      return Promise.resolve(response.data[0]);
    })
    .catch((err) => {
      return 500;
    });
};

export const consultarGratuidadeSenior = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.ConsultaGratuidadeSenior(id)}`)
    .then((response) => {
      if (response !== 400 && response !== 404 && response !== 500) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const consultarGratuidadeEstudante = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.ConsultaGratuidadeEstudante(id)}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const consultarPenalizacaoGratuidade = async (idCliente, idProduto) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  return await axios
    .get(`${Endpoints.ConsultaPenalizacaoGratuidade(idCliente, idProduto)}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const buscarLojasNaAPI = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.GetLojas}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const salvaGratuidade = (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.SalvaGratuidade, params)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const aprovarGratuidade = async (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .post(Endpoints.AprovarGratuidade, params)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((err) => {
      return err.response?.data || "Erro ao aprovar gratuidade";
    });
};

export const editaGratuidade = (params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.SalvaGratuidade, params)
    .then((response) => {
      console.error("Erro ao aprovar 2  gratuidade API:", response);
      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const buscarValor2via = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.GetValorSegundaVia}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      // return err?.response?.status;
    });
};

export const buscar2Via = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.GetTaxa2Via(id))
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const buscarMidiasUsuario = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.GetMidiasUsuario(id))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 400;
    });
};

export const finalizarPedidoCartao = (body) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(`${Endpoints.PedirCartaoTransporteGratuidade}`, body)
    .then((response) => {
      return response.status;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const finalizarPedidoCartaoAtendimento = (body) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(`${Endpoints.PedirCartaoTransporteAtendimento}`, body)
    .then((response) => {
      return response.status;
    })
    .catch((err) => {
      return 500;
    });
};

export const buscarTaxaEntrega = (cep) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.TaxaEntrega(cep))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const recuperarLinhaDigitavel = async (pedido) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.RecuperarLinhaDigitavel(pedido))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err.request.status;
    });
};

export const buscarHistoricoUltimosSetePedidos = async (
  numDocumento,
  idProduto,
  filtro,
) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarHistorico7dias(numDocumento, idProduto, filtro))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const buscarHistoricoExtratoMacae = async (
  periodo,
  daterange,
  idBeneficiario,
) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  let dataInicio = null;
  let dataFim = null;

  if (!periodo && daterange) {
    dataInicio = formataDataFiltro(daterange.startDate);
    dataFim = formataDataFiltro(daterange.endDate);
  }

  const body = {
    idBeneficiario,
    dataInicio,
    dataFim,
    periodo,
    atendimento: true,
  };

  return await axios
    .post(Endpoints.BuscarHistoricoMacae, body)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const buscarHistoricoMidia = async (idMidia) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarHistoricoMidia(idMidia))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const buscarHistoricoPedidos = async (
  codigoCliente,
  idProduto,
  filtro,
) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  var dataFinal = "";
  let dataIni = "";

  dataIni = formataDataFiltro(filtro.startDate);
  dataFinal = formataDataFiltro(filtro.endDate);

  const body = {
    idCliente: codigoCliente,
    idProduto: idProduto,
    de: dataIni + "T00:00:00",
    ate: dataFinal + "T23:59:59",
  };

  return await axios
    .post(Endpoints.BuscarHistoricoPedidos, body)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};
export const buscarHistoricoPedidoCartao = async (idCliente, idProduto) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarSeTemPedido(idCliente, idProduto))
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const listarGratuidade = (codigoCliente, idGratuidade) => {
  const body = {
    cdCliente: codigoCliente,
    idTipoGratuidade: idGratuidade,
  };

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.listarGratuidadePorCliente, body)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const docsObrigatorios = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.DocsObrigatorios}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      return err;
    });
};

export const cancelarPedidoApi = async (bodyPedido) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .put(`${Endpoints.CalcelarPedido}`, bodyPedido)
    .then((response) => {
      return response.status;
    })
    .catch((err) => {
      return err;
    });
};

export const salvarDocsGratuidade = (tipo, idGratuidade, file) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  return axios
    .post(Endpoints.SalvaDocsGratuidade(tipo, idGratuidade), file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.status)
    .catch((err) => {
      console.error(err);
    });
};

export const salvarLaudo = (bodyLaudo) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.SalvaLaudo, bodyLaudo)
    .then((response) => {
      if (response.status === 200) {
        return 200;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const buscarLaudo = async (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.BuscaLaudo(id))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const alterarLaudo = (bodyLaudo) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.SalvaLaudo, bodyLaudo)
    .then((response) => response.status)
    .catch((err) => {
      console.error(err);
    });
};

export const listarDocsGratuidade = async (idGratuidade) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.ListaDocsGratuidade}/${idGratuidade}`)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const buscarBoletoBase64 = async (numeroPedido) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarBoleto(numeroPedido))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const gerarBoletoBase64 = async (numeroPedido) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  try {
    const response = await axios.get(Endpoints.GerarBoleto(numeroPedido));
    return response;
  } catch (err) {
    console.error(err);
  }
};

const verificarStatus = async (numeroPedido) => {
  const startTime = Date.now();
  const timeout = 5000; //5seg
  const interval = 1000;

  const intervalId = setInterval(async () => {
    const elapsedTime = Date.now() - startTime;

    if (elapsedTime >= timeout) {
      clearInterval(intervalId);
      return;
    }

    try {
      const response = await axios.get(Endpoints.GerarBoleto(numeroPedido));
      if (response?.status === 200 && response?.data?.mensagem === "OK") {
        clearInterval(intervalId);
        buscarBoletoBase64(numeroPedido);
      }
    } catch (err) {
      console.error("Erro ao gerar boleto:", err);
      clearInterval(intervalId);
    }
  }, interval);
};

export const getSaldoContaClienteId = async (cliente) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarSaldoContaVirtual(cliente.codigo))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const getSaldoContaCliente = async (idCliente) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarSaldoContaVirtual(idCliente))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// export const buscarHistoricoUtilizacaoDeContaVirtual = (requestFiltro) => {
//   axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
//   return axios
//     .post(Endpoints.BuscarHistoricoContaVirtual, requestFiltro)
//     .then((response) => {
//       if (response.status === 200) {
//         return response.data;
//       } else {
//         return response.status;
//       }
//     })
//     .catch((err) => {
//       return err.request.status;
//     });
// };

export const salvaRegras = (idGratuidade, params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.SalvarRegras(idGratuidade), params)
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else return [];
    })
    .catch((erro) => console.log("Erro ao cadastrar regras", erro));
};

export const atualizarRegras = (idGratuidade, params) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.SalvarRegras(idGratuidade), params)
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else return [];
    })
    .catch((erro) => console.log("Erro ao cadastrar regras", erro));
};

export const consultarRastreio = (nrRastreio) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.Rastreio(nrRastreio))
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else return 400;
    })
    .catch((err) => {
      return 500;
    });
};
export const buscarRegrasPorGratuidade = async (idGratuidade) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(Endpoints.BuscarRegrasPorGratuidade(idGratuidade))
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else return [];
    })
    .catch((erro) => console.log("Erro ao listar regras", erro));
};

export const getListaMotivosCancelamento = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.BuscarMotivosDeCancelamentoDeCartao}`)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      return 400;
    });
};

export const buscarBloqueioConta = async (cpf) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.BuscarBloqueioConta(cpf)}`)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return 404;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const getListaMotivosCancelamentoPedido = async () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return await axios
    .get(`${Endpoints.BuscarMotivosDeCancelamentoDePedido}`)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return response.status;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const realizarPedidoRecarga = (bodyPedido) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(`${Endpoints.PedidoRecarga}`, bodyPedido)
    .then((response) => {
      return response.request.status;
    })
    .catch((err) => {
      return err;
    });
};

export const buscaCep = async (cep) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");

  return axios
    .get(`${Endpoints.BuscaCep(cep)}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const obterTransacaoDetalhe = async (bodyParams) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.BuscarTransacao, bodyParams)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.error("Erro ao obter transação detalhe:", err);
      return null;
    });
};

export const buscaHitoricoStatusGratuidade = (idCliente, idTipoGratuidade) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  const body = {
    cdCliente: idCliente,
    idTipoGratuidade: idTipoGratuidade,
  };

  return axios
    .post(`${Endpoints.BuscarStatusGratuidade}`, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const cancelamentoCartao = (body) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.CancelarCartao, body)
    .then((response) => {
      return response.request.status;
    })
    .catch((err) => {
      return err;
    });
};

export const valor2Via = (idProduto) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.GetValorSegundaVia(idProduto))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

export const bloquearCartao = (midia) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(`${Endpoints.BloquearCartao}${midia}`)
    .then((response) => {
      return response.request.status;
    })
    .catch((err) => {
      return err;
    });
};

export const desbloquearCartao = (midia) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(`${Endpoints.DesbloquearCartao}${midia}`)
    .then((response) => {
      return response.request.status;
    })
    .catch((err) => {
      return err;
    });
};

export const pesquisarTicketEmail = async (emailUsuario) => {
  const body = {
    email: emailUsuario,
  };

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.PesquisaProtocolo, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const getDataByStatusGratuidades = (status) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.BuscarTodasStatusGratuidades(status))
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return 500;
    });
};

export const getAllDataZenDesk = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.BuscarTodosAtendimentos)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else if (response.status == 401 || response.status == 403) {
        return 403;
      } else {
        return 404;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const enviaEmailAtendimento = (bodyChamado) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.EnviaEmailAtendimento, bodyChamado)
    .then((response) => {
      return response.status;
    })
    .catch((err) => {
      return err;
    });
};

//------------------------AUDITORIA------------------------------------------------------
export const getImagensTransacoes = (
  index,
  qtdBusca,
  status,
  numCartao,
  ordem,
  idCliente,
) => {
  var body = {};
  !status
    ? (body = {
      index: index,
      numeroCartao: !numCartao ? null : numCartao,
      quantidade: qtdBusca,
      ordem: !ordem ? "asc" : ordem,
      idCliente,
    })
    : (body = {
      index: index,
      idStatus: status,
      numeroCartao: !numCartao ? null : numCartao,
      quantidade: qtdBusca,
      ordem: !ordem ? "asc" : ordem,
      idCliente,
    });

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.imagensTransacoes, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const getAuditarImagem = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.auditarImagem)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const confirmarUsoIndevidoCliente = (id) => {
  const usuarioAuditoriaNumDocumento = JSON.parse(localStorage.getItem("user"));
  const body = {
    idImagemTransacao: id,
    cdContaAcesso: usuarioAuditoriaNumDocumento.jti,
  };
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.confirmarUsoIndevido, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const cartaoModelos = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.getCartaoModelos)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const confirmarBiometriaCliente = (id) => {
  const usuarioAuditoriaNumDocumento = JSON.parse(localStorage.getItem("user"));
  const body = {
    idImagemTransacao: id,
    cdContaAcesso: usuarioAuditoriaNumDocumento.jti,
  };
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .put(Endpoints.confirmarBiometria, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const getIdClienteByNumeroLogico = (numeroLogicoMidia) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.getClienteByNumeroLogico(numeroLogicoMidia))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const getClienteById = (idCliente) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.getClienteById(idCliente))
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const getAllStatusPagination = (
  index,
  qtdBusca,
  ordem,
  idTipoGratuidade,
  idStatus,
  idCLiente,
) => {
  var body = {};
  !idStatus
    ? (body = {
      index: index,
      quantidade: qtdBusca,
      ordem: !ordem ? "asc" : ordem,
      idCliente: idCLiente,
      idTipoGratuidade: idTipoGratuidade,
    })
    : (body = {
      index: index,
      idStatus: idStatus,
      idCliente: idCLiente,
      quantidade: qtdBusca,
      idTipoGratuidade: idTipoGratuidade,
      ordem: !ordem ? "asc" : ordem,
    });

  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .post(Endpoints.BuscarStatusPaginacao, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};

export const getAllStatus = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.BuscarStatus)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};

export const getResumoStatus = () => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.ResumoTodos)
    .then((response) => {
      if (response.status < 400) {
        return response.data;
      } else {
        return 400;
      }
    })
    .catch((err) => {
      return err?.response?.status;
    });
};
export const getIdClienteByNumeroDocumento = (numDoc) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.getClienteByNumeroDocumento(numDoc))
    .then((response) => {
      return response?.data?.codigo;
    })
    .catch((err) => {
      return 400;
    });
};

export const getFotoById = (id) => {
  axios.defaults.headers.Authorization = sessionStorage.getItem("_bpAuth");
  return axios
    .get(Endpoints.getFotoById(id))
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return 400;
    });
};
